import { MGPOptional } from '@everyboard/lib';
import { BooleanConfig } from '../../../config/BooleanConfig';
import { NumberConfig } from '../../../config/NumberConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from '../../../config/RulesConfigDescriptionLocalizable';
import { MGPValidators } from '../../../utils/MGPValidator';
import { AbstractRectangularGoRules } from '../abstract-rectangular-go/AbstractRectangularGoRules';
export class ZoomedGoRules extends AbstractRectangularGoRules {
    static singleton = MGPOptional.empty();
    static zoom(z) {
        return $localize `Zoom ${z}`;
    }
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => ZoomedGoRules.zoom(3) + ' ' + $localize `(medium)`,
        config: {
            width: new NumberConfig(12, RulesConfigDescriptionLocalizable.WIDTH, MGPValidators.range(1, 99)),
            height: new NumberConfig(12, RulesConfigDescriptionLocalizable.HEIGHT, MGPValidators.range(1, 99)),
            handicap: new NumberConfig(0, () => $localize `Handicap`, MGPValidators.range(0, 9)),
            zoom: new NumberConfig(3, () => $localize `Zoom`, MGPValidators.range(1, 5)),
            showZooms: new BooleanConfig(true, () => $localize `Show zooms`),
        },
    }, [
        {
            name: () => ZoomedGoRules.zoom(2) + ' ' + $localize `(small)`,
            config: {
                width: 6,
                height: 6,
                handicap: 0,
                zoom: 2,
                showZooms: true,
            },
        }, {
            name: () => ZoomedGoRules.zoom(2) + ' ' + $localize `(medium)`,
            config: {
                width: 10,
                height: 10,
                handicap: 0,
                zoom: 2,
                showZooms: true,
            },
        }, {
            name: () => ZoomedGoRules.zoom(2) + ' ' + $localize `(large)`,
            config: {
                width: 14,
                height: 14,
                handicap: 0,
                zoom: 2,
                showZooms: true,
            },
        }, {
            name: () => ZoomedGoRules.zoom(3) + ' ' + $localize `(small)`,
            config: {
                width: 6,
                height: 6,
                handicap: 0,
                zoom: 3,
                showZooms: true,
            },
        }, {
            name: () => ZoomedGoRules.zoom(3) + ' ' + $localize `(large)`,
            config: {
                width: 18,
                height: 18,
                handicap: 0,
                zoom: 3,
                showZooms: true,
            },
        },
    ]);
    static get() {
        if (ZoomedGoRules.singleton.isAbsent()) {
            ZoomedGoRules.singleton = MGPOptional.of(new ZoomedGoRules());
        }
        return ZoomedGoRules.singleton.get();
    }
    constructor() {
        super(true);
    }
    getRulesConfigDescription() {
        return ZoomedGoRules.RULES_CONFIG_DESCRIPTION;
    }
}
